import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  let data = isSuccessResponse(response)
  return data
}

// {
//   "configDetails": [
//       {
//           "configType": "PAYMENT_ACCEPTANCE",
//           "configValues": [
//               {
//                   "status": "ACTIVE",
//                   "key": "600",
//                   "value": "Y"
//               },
//               {
//                   "status": "ACTIVE",
//                   "key": "595",
//                   "value": "Y"
//               }
//           ]
//       },
//       {
//           "configType": "ALLOWED_RETRIES",
//           "configValues": [
//               {
//                   "status": "ACTIVE",
//                   "key": "RETRY_COUNT",
//                   "value": "4"
//               }
//           ]
//       },
//       {
//           "configType": "TIMEOUT",
//           "configValues": [
//               {
//                   "status": "ACTIVE",
//                   "key": "CLOSE_TIME",
//                   "value": "2000"
//               }
//           ]
//       }
//   ]
// }

const getConfigInsertRequest = (mid: string, configList: any[], isUpdateRequired: boolean) => {
  return {
    mid: mid,
    configDetails: configList,
    updateRequired: isUpdateRequired ? 'Y' : 'N',
  }
}

const insertConfig = (mid: string, config: any[], isUpdateRequired: boolean, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.configInsert),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: getConfigInsertRequest(mid, config, isUpdateRequired),
  }

  return executeRequest(request)
    .then((resp) => responseParser(resp))
    .catch((error) => {
      throw error
    })
}

export { insertConfig }
